export const scrubPhoneNumber = (phoneNumber: string): string => phoneNumber.replace(/\D/g, '');
